import { all, call, put, race, take, takeEvery } from 'redux-saga/effects'
import { FormActions } from '../../reducers/form/actionNames'

const getPayload = data => (data && data.payload) || data

export function* handleFormPromiseAction(action) {
  const {
    payload,
    meta: {
      formActions,
      noSuccessPayload,
      defer: { resolve, reject },
    },
  } = action

  const [{ success, failure }] = yield all([
    race({
      failure: take(formActions.FAILURE),
      success: take(formActions.SUCCESS),
    }),
    put(formActions.trigger(payload)),
  ])

  if (success) {
    yield noSuccessPayload ? call(resolve) : call(resolve, getPayload(success))
  } else {
    yield call(reject, getPayload(failure))
  }
}

export default function* routinePromiseWatcherSaga() {
  yield takeEvery(FormActions.Promise, handleFormPromiseAction)
}
